/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */
import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { jwtDecode } from 'jwt-decode';
import { call, put, takeLatest } from 'redux-saga/effects';

import apiNew from '../../api/api';
import { errorHandling } from '../../api/errorHandling';
import {
 deleteCookieCustom,
 getCookieCustom,
 setCookieCustom,
} from '../../utils/cookies';
import {
 identityLoginFailure,
 identityLoginStart,
 identityLoginSuccess,
 identityLogoutStart,
 identityLogoutSuccess,
} from './identitySlice';

function* identityLoginSaga(
 props: PayloadAction<{ email: string; password: string }>,
) {
 try {
  const response: AxiosResponse<{
   access_token: string;
   expiration: number;
   refresh_token: string;
   configuration: string;
  }> = yield call(apiNew.post, '/Identity/v1/login', props.payload);

  const {
   access_token: accessTokenNew,
   refresh_token: refreshTokenNew,
   expiration: expirationNew,
   configuration: configurationNew,
  } = response.data;

  const decoded = jwtDecode(accessTokenNew);

  // Store the new access and refresh tokens.
  setCookieCustom('access_token', accessTokenNew, expirationNew);
  setCookieCustom('refresh_token', refreshTokenNew, expirationNew);
  setCookieCustom('expiration', expirationNew.toString(), expirationNew);
  setCookieCustom('user_id', (decoded as any)?.userId, expirationNew);
  localStorage.setItem('configuration', JSON.stringify(configurationNew));

  yield put(
   identityLoginSuccess({
    accessToken: response.data.access_token,
    refreshToken: response.data.refresh_token,
    expiration: response.data.expiration,
   }),
  );
 } catch (error) {
  yield* errorHandling(error, identityLoginFailure);
 }
}

function* identityLogoutSaga() {
 try {
  const response: AxiosResponse<{
   access_token: string;
   expiration: number;
   refresh_token: string;
  }> = yield call(apiNew.post, '/Identity/v1/logout', {
   access_token: getCookieCustom('access_token'),
  });

  deleteCookieCustom('access_token', '/');
  deleteCookieCustom('refresh_token', '/');
  deleteCookieCustom('expiration', '/');
  deleteCookieCustom('user_id', '/');
  deleteCookieCustom('configuration', '/');

  yield put(identityLogoutSuccess({}));
  window.location.href = '/login';
 } catch (error) {
  yield* errorHandling(error, identityLoginFailure);
 }
}

export function* watchIdentitySaga() {
 yield takeLatest(identityLoginStart.type, identityLoginSaga);
 yield takeLatest(identityLogoutStart.type, identityLogoutSaga);
}
